<template>
  <basic-container>
    <el-dialog
      title="查看开账记录"
      :visible.sync="openFlag"
      :modal-append-to-body="false"
      width="64%"
      @closed="handleClose"
      append-to-body
    >
      <div style="height: auto; padding-bottom: 30px;">
        <avue-crud
          v-if="reWrite"
          :option="option"
          :table-loading="loading"
          :data="data"
          :page="page"
          :permission="permissionList"
          :before-open="beforeOpen"
          v-model="form"
          ref="crud"
          @row-update="rowUpdate"
          @row-save="rowSave"
          @row-del="rowDel"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @on-load="onLoad"
          @refresh-change="onLoad"
        >
          <template slot="menuLeft">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              v-if="permission.departmentacccycle_delete"
              @click="handleDelete"
              >删 除
            </el-button>
          </template>
        </avue-crud>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/department/departmentacccycle';
import { mapGetters } from 'vuex';
import { getDepartmentCommunityTree } from '../../../api/v4ward/property/baseproperty';
export default {
  data() {
    return {
      openFlag: false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      tempCommunityId: '',
      firstDisplayFlag: false,
      communityList: [],
      reWrite: false,
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 50,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        columnBtn: false,
        refreshBtn: false,
        menu: false,
        searchMenuSpan: 6,
        column: [
          {
            lazy: false,
            label: '开账小区',
            prop: 'communityId',
            type: 'tree',
            search: true,
            props: {
              label: 'title',
              value: 'id',
            },
            dicUrl: '/api/base/property/getDepartmentCommunityTree',
          },
          {
            label: '开账年月',
            prop: 'accountCycle',
            type: 'month',
            format: 'yyyyMM',
            valueFormat: 'yyyyMM',
            search: true,
          },
          {
            label: '开账状态',
            prop: 'openFlag',
            type: 'select',
            dataType: 'number',
            search: true,
            dicUrl: 'api/blade-system/dict/dictionary?code=open_flag',
            props: { label: 'dictValue', value: 'dictKey' },
          },

          {
            label: '提交人',
            prop: 'createAccount',
          },
          {
            label: '提交任务时间',
            prop: 'createTime',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.departmentacccycle_add, false),
        viewBtn: this.vaildData(this.permission.departmentacccycle_view, false),
        delBtn: this.vaildData(this.permission.departmentacccycle_delete, false),
        editBtn: this.vaildData(this.permission.departmentacccycle_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    //加载列表
    getDepartmentCommunityTree({}).then((res) => {
      this.communityList = res.data;
      if (this.communityList.length > 0) {
        this.query.communityId = this.communityList[0].id;
        this.tempCommunityId = this.communityList[0].id;
      }
      this.$nextTick(() => {
        this.reWrite = true;
      });
      //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
      this.firstDisplayFlag = true;
    });
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //开启默认搜索第一个小区
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (this.query.communityId == undefined || this.query.communityId == '') {
        this.query.communityId = this.tempCommunityId;
      }
      if (this.query.communityId) {
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="开账小区"]');
              ent.value = this.communityList.length > 0 ? this.communityList[0].title : '';
              this.query.communityId =
                this.communityList.length > 0 ? this.communityList[0].id : '';
              //关闭默然显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          }
        );
      } else {
        this.loading = false;
      }
    },
    openOpenAccountRecordDialog() {
      this.onLoad();
      this.openFlag = true;
    },
  },
};
</script>

<style></style>
